import { render, staticRenderFns } from "./AddReviewModal.vue?vue&type=template&id=912bf690&scoped=true"
import script from "./AddReviewModal.vue?vue&type=script&lang=js"
export * from "./AddReviewModal.vue?vue&type=script&lang=js"
import style0 from "./AddReviewModal.vue?vue&type=style&index=0&id=912bf690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912bf690",
  null
  
)

export default component.exports